import React, {Component} from 'react';

class NormalButton extends Component {

    static defaultProps = {
        style: {},
        onClick: ()=>{}
    };

    render() {
        return (
            <span style={ {cursor:"pointer", ...this.props.style}} onClick={()=>this.props.onClick()}>
                <img src={this.props.icon} width={14}/>
                <span style={{color:"#fff",marginLeft:5}}>{this.props.text}</span>
            </span>
        );
    }
}

export default NormalButton;